// @ts-nocheck

import { Howl } from 'howler';

import { isIOSEmbeddedAndStandalone } from '../client';
import { MUTE_LOCAL_STORAGE_NAME } from '../constants/storage';
import { callNative } from '../lib/bridge/ios';
import RequestTypes from '../lib/bridge/requestTypes';

const fetchIOSSound = () => ({
  load: (soundId, soundUrl) => callNative(RequestTypes.LOAD_SOUND, { soundId, soundUrl }),
  play: (soundId) => callNative(RequestTypes.PLAY_SOUND, { soundId }),
  stop: (soundId) => callNative(RequestTypes.STOP_SOUND, { soundId }),
});

export const fetchSound = async (resource, soundId): Promise<SoundInstance> =>
  new Promise((resolve, reject) => {
    if (isIOSEmbeddedAndStandalone) {
      const iosSoundPlayer = fetchIOSSound();
      const path = `/betting/${resource.src}`;

      iosSoundPlayer
        .load(soundId, path)
        .then(() => {
          const sound = {
            play: () => {
              try {
                const item = window.localStorage.getItem(MUTE_LOCAL_STORAGE_NAME);
                const isMuted = item ? JSON.parse(item) : false;
                if (!isMuted) {
                  return iosSoundPlayer.play(soundId);
                }
              } catch (e) {
                console.log(e);
              }
            },
            stop: () => iosSoundPlayer.stop(soundId),
            mute: () => iosSoundPlayer.stop(soundId),
            src: resource.src,
            unmute: () => {},
            getDuration: () => {},
            getState: () => 'loaded',
            on: () => {},
          };

          resolve(sound);
        })
        .catch(() => {
          reject();
        });
    } else {
      const newSound = new Howl({
        src: resource.src,
        sprite: resource.sprite,
      });

      newSound.on('load', () => {
        const sound = {
          play: () => newSound.play(resource.spriteId),
          stop: () => newSound.stop(),
          mute: () => newSound.mute(true, resource.spriteId),
          unmute: () => newSound.mute(false, resource.spriteId),
          getDuration: (): number => newSound.duration(),
          getState: (): 'unloaded' | 'loading' | 'loaded' => newSound.state(),
          on: (eventName: string, callback: () => void) => newSound.on.bind({}, eventName, callback),
          src: resource.src,
        };

        resolve(sound);
      });
    }
  });
